import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router';
import GlobalStyle from './styles/globalStyles';
import { ThemeProvider } from 'styled-components';
import { theme } from './styles/theme';
import Header from './components/Header/Header';
import RegisterLanding from './components/RegisterLanding/RegisterLanding';
import Home from './components/Home/Home';
import Settings from './components/Settings/Settings';
import { AppContainer } from './App.styles';
import { UserProvider } from './context/UserContext';

function AppLayout() {
  const location = useLocation();
  const isLanding = location.pathname === '/';

  return (
    <AppContainer>
      {!isLanding && <Header />}
      <Routes>
        <Route path="/home" element={<Home />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/" element={<RegisterLanding />} />
      </Routes>
    </AppContainer>
  );
}

function App() {
  return (
    <Router>
      <UserProvider>
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          <AppLayout />
        </ThemeProvider>
      </UserProvider>
    </Router>
  );
}

export default App;
